import React from 'react';
import { MdScheduleSend } from 'react-icons/md';

const RETENTION_DAYS = 90;

export const RetentionNotice: React.FC = () => (
    <div className="chat-ai-sidebar__retention" role="note" aria-label="Срок хранения истории">
        <MdScheduleSend size={13} aria-hidden />
        <span>
            История хранится <strong>{RETENTION_DAYS}</strong> дней
        </span>
    </div>
);
